import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  isAuthenticated: false,
  accessToken: null,
  profile: null,
  displayName: '',
}

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setAccessToken: (state, action) => {
      const accessToken = action.payload;
      state.accessToken = accessToken;
      state.isAuthenticated = !!accessToken;
    },
    setProfile: (state, action) => {
      const profile = action.payload;
      state.displayName = profile.display_name;
      // const profile = action.payload;
      // return {
      //   ...state,
      //   profile,
      // }
    },
  },
})

// Action creators are generated for each case reducer function
export const { setAccessToken, setProfile } = authSlice.actions

export default authSlice.reducer